export const getClassTextTheme = (value?: string) => {
  const PREFIX = 'vitrine-template2__card--text';
  if (!value || value === '' || value === 'default') {
    return '';
  }
  return `${PREFIX}--${value}`;
};

export const sliceText = (value: string, maxChars = 45) => {
  if (value.length > maxChars) {
    return `${value.slice(0, maxChars)}...`;
  }
  return value;
};
